/**
 * Route for `partnerstack-integration-via-api`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { PartnerstackIntegrationViaApiPage } from "../features/partnerstack-integration-via-api/PartnerstackIntegrationViaApiPage";

export const partnerstackIntegrationViaApiRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/partnerstack-integration-via-api",
	component: PartnerstackIntegrationViaApiPage,
});

export default partnerstackIntegrationViaApiRoute;
